import { render, staticRenderFns } from "./realTimeLoad.vue?vue&type=template&id=ae46a61e&scoped=true&"
import script from "./realTimeLoad.vue?vue&type=script&lang=js&"
export * from "./realTimeLoad.vue?vue&type=script&lang=js&"
import style0 from "./realTimeLoad.vue?vue&type=style&index=0&id=ae46a61e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae46a61e",
  null
  
)

export default component.exports